export default __webpack_public_path__ + "static/media/img_01.e6d41d4d.svg";